import React from "react";
import { graphql } from "gatsby";
import { Header } from "semantic-ui-react";
import { injectIntl } from "gatsby-plugin-intl";
import Layout from "../components/Layout";
import { Block } from "../components/StyledComponent";

const EULAPage = ({ data }) => {
  const { markdownRemark } = data;
  const { html } = markdownRemark;

  return (
    <Layout>
      <Block color="gray">
        <Header
          as="h1"
          textAlign="center"
          size="huge"
          style={{ marginBottom: "1em" }}
        >
          End User License Agreement
        </Header>
        <div
          dangerouslySetInnerHTML={{ __html: html }} //eslint-disable-line
        />
      </Block>
    </Layout>
  );
};

export default injectIntl(EULAPage);

export const pageQuery = graphql`
  query {
    markdownRemark(frontmatter: { path: { eq: "eula" } }) {
      html
    }
  }
`;
